export default function FeaturesSection() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <h2 className="text-[36px] md:text-[48px] font-heading text-foreground-950 leading-[1.1]">
            Why Itaobuy<br />
            <span className="italic text-foreground-600">Works Better</span>
          </h2>
          <p className="text-[13px] text-foreground-600 max-w-[320px] leading-relaxed">
            Key advantages that make the itaobuy spreadsheet system the smarter choice for online product research.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="rounded-2xl overflow-hidden">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20organized%20workspace%20with%20clean%20spreadsheet%20layout%20and%20fashion%20catalog%20images%20neatly%20displayed%20on%20screen%2C%20warm%20natural%20sunlight%2C%20minimalist%20modern%20desk%2C%20editorial%20photography%2C%20cream%20tones&width=600&height=400&seq=feature-v4-1&orientation=landscape"
                alt="Smart Comparison"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="bg-background-100 p-6 rounded-b-2xl">
              <h3 className="text-[15px] font-semibold text-foreground-950 mb-2">Smart Comparison</h3>
              <p className="text-[12px] text-foreground-600 leading-relaxed">
                Compare multiple products side by side in a clean spreadsheet layout. Identify the best value across categories like Shoes, Hoodies, Jackets, and more without switching between tabs.
              </p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden">
            <div className="h-36 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Sleek%20modern%20digital%20interface%20with%20organized%20product%20categories%20and%20clean%20navigation%20menu%2C%20bright%20airy%20office%20setting%2C%20contemporary%20minimalist%20design%2C%20efficient%20technology%20concept&width=600&height=300&seq=feature-v4-2&orientation=landscape"
                alt="Fast Navigation"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="bg-background-100 p-6 rounded-b-2xl">
              <h3 className="text-[15px] font-semibold text-foreground-950 mb-2">Fast Navigation</h3>
              <p className="text-[12px] text-foreground-600 leading-relaxed">
                Jump directly to any of 14 product categories with one click. The itaobuy spreadsheet organizes everything logically so you spend less time searching and more time finding.
              </p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden">
            <div className="h-36 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Fresh%20updated%20modern%20digital%20dashboard%20showing%20live%20product%20inventory%20data%2C%20clean%20organized%20interface%2C%20professional%20bright%20workspace%2C%20natural%20daylight%2C%20contemporary%20office&width=600&height=300&seq=feature-v4-3&orientation=landscape"
                alt="Always Updated"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="bg-background-100 p-6 rounded-b-2xl">
              <h3 className="text-[15px] font-semibold text-foreground-950 mb-2">Always Updated</h3>
              <p className="text-[12px] text-foreground-600 leading-relaxed">
                Product listings, prices, and availability are continuously refreshed to reflect the latest data. Make decisions based on current information, not outdated listings.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}